import { useState, useMemo } from 'react';
import { FieldAttributes } from 'formik';
import {
    DatePicker as MuiDatePicker,
    DatePickerProps,
} from 'formik-mui-x-date-pickers';
import { useTranslation } from 'react-i18next';
import { DateValidationError } from '@mui/x-date-pickers';

import { getDateFormat } from 'common/utils/getDateFormat';
import { valueToDateTime } from 'common/utils/formatDate';

export const DatePicker = ({
    label,
    value,
    onChange,
    ...other
}: FieldAttributes<DatePickerProps>) => {
    const dateFormat = getDateFormat();
    const [translate] = useTranslation();

    const [error, setError] = useState<DateValidationError | null>(null);

    const errorMessage = useMemo(() => {
        switch (error) {
            case 'maxDate':
                return translate('maxDateMessage');

            case 'minDate':
                return translate('minDateMessage');

            case 'invalidDate': {
                return translate('invalidDateMessage');
            }

            default:
                return '';
        }
    }, [error]);

    const { field } = other;
    const fieldValue = value || field.value;

    // Make sure we have a luxon DateTime object
    field.value = valueToDateTime(fieldValue);

    return (
        <MuiDatePicker
            format={dateFormat}
            textField={{
                fullWidth: true,
                margin: 'normal',
                label: label,
                helperText: errorMessage,
                sx: {
                    '& .MuiPickersInputBase-sectionsContainer': {
                        py: 2,
                    },
                },
            }}
            onError={(newError) => setError(newError)}
            {...other}
        />
    );
};
